export default __webpack_public_path__ + "static/national-metric-desktop-0073f3a05b941bdb12ef00f1f0de8ff0.svg";